<script>
import ApiService from "@/api-services/portal.service";

export default {
  name: "portal",
  components: {},
  data: function () {
    return {
      employee: { firstname: "" },
    };
  },
  methods: {
    getEmployeeInformation: async function () {
      ApiService.getEmployeeInformations()
        .then((response) => {
          this.employee = response.data.requestResult;
        })
        .catch((error) => {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.$store.commit("setJwt", null);
              this.$store.commit("setIsAuthentified", false);
              this.$router.push("/");
            } else {
              this.$store.commit(
                "setNewErrorMessage",
                error.response.data.requestResult
              );
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
          console.log(error.response.data);
        });
    },
  },

  async created() {
    await this.getEmployeeInformation();
  },
};
</script>

<template>
  <v-main>
    <v-container id="portal">
      <v-navigation-drawer app permanent clipped>
        <v-list>
          <v-list-item>
            <v-list-item-content class="text-center align-self-start">
              <v-list-item-title style="text-align: -webkit-center">
                <v-img
                  :lazy-src="
                    'data:image/jpeg;base64,' +
                    this.$store.state.portalConfiguration.logoPortal
                  "
                  max-height="200"
                  max-width="100"
                  contain
                  :src="
                    'data:image/jpeg;base64,' +
                    this.$store.state.portalConfiguration.logoPortal
                  "
                ></v-img>
                <v-img
                  lazy-src="/monAdnLight.png"
                  max-height="200"
                  max-width="130"
                  contain
                  src="/monAdnLight.png"
                ></v-img>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mb-2"></v-divider>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="text-uppercase text-center">
                {{ employee.firstName }} {{ employee.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-center">{{
                employee.personnalEmail
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list dense>
          <v-list-item-group color="primary">
            <v-list-item link router to="/Portal/Dashboard">
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>

              <v-list-item-title>Tableau de bord</v-list-item-title>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>

      <!-- Sizes your content based upon application components -->
      <v-main class="pl-1 pt-0">
        <!-- Provides the application the proper gutter -->
        <v-container fluid>
          <!-- If using vue-router -->
          <router-view></router-view>
        </v-container>
      </v-main>
    </v-container>
  </v-main>
</template>

<style>
@media (min-width: 600px) {
  .headerStep {
    margin-left: 20%;
    margin-right: 20%;
  }
}
</style>
